export const API_URL = `https://api.stories-for-life.com`;
